import React from "react";
import { Box } from "@mui/material";
import { Button, Modal } from "@gpstrackit/gtc-react-controls";
import { useIntl } from "react-intl";

export const DeleteFace = ({
  openModalDeleteFaceId,
  setFaceIdDelete,
  setOpenModalDeleteFaceId,
  deleteFaceId,
}) => {
  const { messages } = useIntl();
  return (
    <Modal
      closeButton
      open={openModalDeleteFaceId}
      footer={
        <div>
          <Button
            onClick={() => {
              setFaceIdDelete("");
              setOpenModalDeleteFaceId(false);
            }}
            style={{ marginRight: 8 }}
            variant="secondary"
          >
            close
          </Button>
          <Button
            onClick={() => {
              setFaceIdDelete("");
              setOpenModalDeleteFaceId(false);
              deleteFaceId();
            }}
            variant="warning"
          >
            {messages["delete"]}
          </Button>
        </div>
      }
      handleClose={() => {
        setFaceIdDelete("");
        setOpenModalDeleteFaceId(false);
      }}
      position="center"
      size="medium"
      title={messages["settingsDriver_driversFacesdeleteFaceIdTitle"]}
    >
      <Box display="flex" flexDirection="column" padding="15px">
        <div
          style={{
            position: "absolute",
            zIndex: "1",
            background: "white",
            marginTop: "-15px",
            paddingTop: "15px",
            marginBottom: "5px",
          }}
        >
          <p>{messages["settingsDriver_driversFacesdeleteFaceId"]}</p>
        </div>
      </Box>
    </Modal>
  );
};
